import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum ArkFoodsInvoiceLineItemKeys {
  itemNumber = 'itemNumber',
  externalItemNumber = 'externalItemNumber',
  description = 'description',
  itemQty = 'itemQty',
  unitPrice = 'unitPrice',
  lineTotal = 'lineTotal',
}

export const arkFoodsInvoiceFileDataSchema = yup.object().shape({
  issuer: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    addressLine1: yup.string().nullable().optional(),
    addressLine2: yup.string().nullable().optional(),
    city: yup.string().nullable().optional(),
    state: yup.string().nullable().optional(),
    zipCode: yup.string().nullable().optional(),
    country: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  recipient: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    addressLine1: yup.string().nullable().optional(),
    addressLine2: yup.string().nullable().optional(),
    city: yup.string().nullable().optional(),
    state: yup.string().nullable().optional(),
    zipCode: yup.string().nullable().optional(),
    country: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  shipTo: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    addressLine1: yup.string().nullable().optional(),
    addressLine2: yup.string().nullable().optional(),
    city: yup.string().nullable().optional(),
    state: yup.string().nullable().optional(),
    zipCode: yup.string().nullable().optional(),
    country: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  companyUrl: yup.string().nullable().optional(),
  invoiceNumber: yup.string().nullable().optional(),
  associatedReferenceNumber: yup.string().nullable().optional(),
  dateIssued: yup.string().nullable().optional(),
  dateDue: yup.string().nullable().optional(),
  paymentTerms: yup.string().nullable().optional(),
  orderNumber: yup.string().nullable().optional(),
  paymentLink: yup.string().nullable().optional(),
  items: yup
    .array()
    .of(
      yup.object().shape({
        itemNumber: yup.number().nullable().optional(),
        description: yup.string().nullable().optional(),
        externalItemNumber: yup.string().nullable().optional(),
        itemQty: yup.string().nullable().optional(),
        unitPrice: yup.string().nullable().optional(),
        lineTotal: yup.string().nullable().optional(),
        lineAmountDue: yup.string().nullable().optional(),
      }),
    )
    .required(),
  shippingRate: yup.string().nullable().optional(),
  paid: yup.string().nullable().optional(),
  agreement: yup.string().nullable().optional(),
  comments: yup.string().nullable().optional(),
})

export type ArkFoodsInvoiceFileData = yup.InferType<typeof arkFoodsInvoiceFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<ArkFoodsInvoiceFileData>

export const arkFoodsInvoiceFileMappings: RequiredFileData = {
  issuer: {
    companyName: '247fb92b-5ce8-424b-bd8d-bb68445022c4',
    addressLine1: 'fdb09592-34b4-4ea0-bc2a-8b9003f95404',
    addressLine2: 'be9e1e7b-aa0e-444a-8198-0ca78bb35966',
    city: '966d970e-43ce-4b6e-b16a-349741d03f97',
    state: 'feeb7da8-367b-40f8-b4de-9ccc1c3c7a74',
    zipCode: 'f2696087-2390-4008-a428-3200bcee2680',
    country: '4fefa469-0260-43d6-9748-ac14f6321260',
    phoneNumber: '4f32f5ad-af88-4068-8076-63573ff818df',
    emailAddress: '26685bcb-5bd6-48f3-9dc5-c06ff8224d0e',
  },
  recipient: {
    companyName: 'cfa9742d-d675-40b0-877f-e898299cb1fd',
    addressLine1: '37b1032b-c148-4b39-8d32-37ff193f3fb1',
    addressLine2: '9851030b-6d23-430d-9115-2133e2557d52',
    city: '3f210944-a913-4e34-990d-df1d3783533f',
    state: '981bba1a-d796-4199-bbdb-f4f55919e6d3',
    zipCode: 'aa7b359a-fb0e-4c24-8323-3a7873c38361',
    country: 'c02f8883-f68a-4c60-9b90-6933f8de038b',
    phoneNumber: '3dac5729-4579-48da-beb0-a54b83b59de5',
    emailAddress: 'fc6dc3a8-e748-45f5-a537-d53d3582a63c',
  },
  shipTo: {
    companyName: 'a745d945-4d0f-479a-af3e-692dd2551e89',
    addressLine1: '7d8eba23-20dd-4e11-8f64-58867d0913c7',
    addressLine2: '02cb59c8-76bc-4787-8423-a110486fed99',
    city: '3d00dc61-844d-459a-ab5e-25c6a61aa27a',
    state: '41e41ae8-db0b-4afc-98f9-a7aa6576264d',
    zipCode: '0461de96-5d95-41f0-9dc9-ed82e3bdcd8d',
    country: 'b4752863-4632-4d08-a571-b27b9a52a66e',
    phoneNumber: '09852c39-0797-44a6-b9fa-5b4364c361a5',
    emailAddress: '051f6e7e-e876-4b8d-bb76-25b588f85618',
  },
  companyUrl: '2c4b45c5-257d-4cc1-99bb-8b33012186ba',
  invoiceNumber: '8a6733f2-cf6a-4e32-994d-7062d34e45df',
  associatedReferenceNumber: '6a29ef7d-1f04-4d3e-9457-95c50d05fd3b',
  dateIssued: '1b476745-aed5-47be-a971-9ad8d6137e64',
  dateDue: 'c1b46307-6a5f-4eb3-afe2-5ef0f48b0908',
  paymentTerms: 'c0c85066-1fff-4d9c-b069-7e0544773ccd',
  orderNumber: '8f819192-7f36-48b4-ab61-947d98cf082d',
  paymentLink: 'b50764a0-e13a-4281-8001-3520bb7747b3',
  items: [
    {
      itemNumber: null,
      description: '21b9c84c-5e67-4952-8822-153520ac527d',
      externalItemNumber: '8b229f54-4fc2-488f-a6aa-01f97e1e0649',
      itemQty: '652f34fb-05ea-4478-a52e-99f9d8ddd8f7',
      unitPrice: 'ba9e5d3f-c6fe-42d0-a5f7-08c4e0a2d2d2',
      lineTotal: null,
      lineAmountDue: '3c148974-2c84-4c29-9f7b-090a2ecad1b8',
    },
  ],
  shippingRate: 'e837149c-4f80-416c-8de3-228eec2655ac',
  paid: '7130d59d-ceca-46ec-93fc-81229d6171d9',
  agreement: '6c3c801d-1452-4a80-a1e6-69a4b70ced26',
  comments: '8f97ee50-1628-4c66-a9a2-7757a96a603c',
}
